export const centsToDollarsAndCents = (amountInCents: number) => {
  return (amountInCents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
};

export const getSwipeDirection = (
  currentIndex: number,
  nextIndex: number,
  lastIndex: number,
) => {
  if (currentIndex === 0 && nextIndex === lastIndex) {
    return 'backward';
  }

  if (currentIndex === lastIndex && nextIndex === 0) {
    return 'forward';
  }

  if (currentIndex > nextIndex) {
    return 'backward';
  }

  return 'forward';
};
